<template>
  <div>
    <vue-dropzone
      :ref="name"
      :id="name"
      :maxFiles="1"
      :options="dropzoneOptions"
      v-on:vdropzone-complete="send"
      :useCustomSlot="true"
    >
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">
          <i class="bx bx-cloud-upload"></i> Drag and drop to upload content
        </h3>
        <!-- <div class="subtitle">or click to select a file from your computer</div> -->
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content,
      dropzoneOptions: {
        url: this.$root.backEnd + "/v1/uploadImage",
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 5,
        acceptedFiles: "image/*",
        headers: {
          "Cache-Control": "",
        },
        successmultiple: this.send,
        paramName: "image",
        // headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  mounted() {
    var file = { size: 123, name: "Icon", type: "image/png" };
    var url = this.$root.backEnd + this.post;

    if (this.post != null && this.post != "") {
      this.$refs[this.name].manuallyAddFile(file, url);
    }
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
  },
  methods: {
    send(response) {
      if (response.xhr != undefined) {
        var res = JSON.parse(response.xhr.response);
        var file = res.file.image;
      }

      this.$emit("post", {
        name: this.name,
        value: file,
      });
    },
    // sendingEvent(file, xhr, formData) {
    //   formData.append("paramName", "some value or other");
    //   console.log(formData);
    // },
  },
};
</script>

<style>
/*
import '~vue-upload-component/dist/vue-upload-component.part.css'
@import "~vue-upload-component/dist/vue-upload-component.part.css";


or


 */
.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4 input[type="file"] {
  opacity: 0;
  font-size: 20em;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.file-uploads.file-uploads-html5 input[type="file"] {
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
/*
img {
  border: 1px solid #ddd; 
  border-radius: 4px; 
  padding: 5px; 
  width: 150px;
}


img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}
*/
</style>